import logger from "src/shared/logger";

const thirdpartyTracker = () => {
    logger.debug('thirdpartyTracker');
}

export default thirdpartyTracker;